import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const PopulationGrowthChart = ({ data, title }) => {
    const chartOptions = {
        chart: {
            type: 'column',
            style: {
                fontFamily: 'SCDream4',
            },
        },
        title: {
            text: title,
            style: {
                fontSize: '16px',
                fontWeight: '600',
                color: '#2c3e50',
                textAlign: 'center',
            },
        },
        xAxis: {
            categories: ['0~9세', '10~19세', '20~29세', '30~39세', '40~49세', '50~59세', '60세 이상'],
            crosshair: {
                color: '#e8e8e8',
                width: 1,
                dashStyle: 'solid',
            },
            lineColor: '#e0e0e0',
            tickColor: '#e0e0e0',
            labels: {
                style: {
                    color: '#555',
                    fontSize: '12px',
                    fontWeight: '500',
                },
            },
        },
        yAxis: [
            {
                title: {
                    text: '인구수',
                    style: {
                        color: '#34495e',
                        fontSize: '13px',
                        fontWeight: '600',
                    },
                },
                labels: {
                    format: '{value}명',
                    style: {
                        color: '#34495e',
                        fontSize: '11px',
                    },
                },
                gridLineColor: '#f0f0f0',
                gridLineWidth: 1,
                lineColor: '#e0e0e0',
                tickColor: '#e0e0e0',
            },
            {
                title: {
                    text: '증감률',
                    style: {
                        color: '#e74c3c',
                        fontSize: '13px',
                        fontWeight: '600',
                    },
                },
                labels: {
                    format: '{value}%',
                    style: {
                        color: '#e74c3c',
                        fontSize: '11px',
                    },
                },
                gridLineColor: 'transparent',
                lineColor: '#e0e0e0',
                tickColor: '#e0e0e0',
                opposite: true,
            },
        ],
        tooltip: {
            backgroundColor: '#ffffff',
            borderColor: '#d0d0d0',
            borderRadius: 6,
            borderWidth: 1,
            shadow: true,
            style: {
                fontSize: '12px',
            },
            shared: true,
            formatter: function () {
                const categoryName = this.points[0].category;
                let tooltip = `
                    <div style="font-weight: 600; color: #2c3e50; margin-bottom: 12px; font-size: 14px;">
                        ${categoryName}
                    </div>
                `;

                this.points.forEach((point) => {
                    if (point.series.name === '인구수, 점유율') {
                        const population = point.y;
                        const percentage = point.percentage || 5.7;

                        tooltip += `
                            <div style="margin: 8px 0; padding: 4px 0; border-bottom: 1px solid #f0f0f0;">
                                <div style="color: #34495e; margin-bottom: 4px;">
                                    <span style="font-weight: 600;">인구수:</span>
                                    <span style="font-weight: 600; color: #3498db; margin-left: 8px;">
                                        ${population.toLocaleString()}명
                                    </span>
                                </div>
                                <div style="color: #7f8c8d;">
                                    <span style="font-weight: 600;">점유율:</span>
                                    <span style="font-weight: 600; color: #7f8c8d; margin-left: 8px;">
                                        ${percentage}%
                                    </span>
                                    <span style="font-size: 11px; color: #95a5a6; margin-left: 4px;">
                                        (2023.12월)
                                    </span>
                                </div>
                            </div>
                        `;
                    } else {
                        tooltip += `
                            <div style="margin: 8px 0; padding: 4px 0;">
                                <div style="color: #e74c3c;">
                                    <span style="font-weight: 600;">${point.series.name}:</span>
                                    <span style="font-weight: 600; color: #e74c3c; margin-left: 8px;">
                                        ${point.y}%
                                    </span>
                                </div>
                            </div>
                        `;
                    }
                });

                return tooltip;
            },
        },
        legend: {
            enabled: true,
            align: 'right',
            verticalAlign: 'top',
            x: -20,
            y: 20,
            itemStyle: {
                color: '#555',
                fontSize: '12px',
                fontWeight: '500',
            },
            itemHoverStyle: {
                color: '#2c3e50',
            },
        },
        plotOptions: {
            column: {
                pointPadding: 0.15,
                groupPadding: 0.1,
                borderWidth: 0,
                color: '#3498db',
                states: {
                    hover: {
                        color: '#2980b9',
                    },
                },
            },
            line: {
                marker: {
                    enabled: true,
                    radius: 5,
                    lineColor: '#ffffff',
                    lineWidth: 2,
                    fillColor: '#e74c3c',
                    states: {
                        hover: {
                            radius: 6,
                            fillColor: '#c0392b',
                        },
                    },
                },
                lineWidth: 3,
                states: {
                    hover: {
                        lineWidth: 4,
                    },
                },
            },
        },
        series: [
            {
                name: '인구수, 점유율',
                type: 'column',
                data: data?.population || [18000, 23000, 48000, 47000, 46000, 49000, 78000],
                yAxis: 0,
                color: '#3498db',
            },
            {
                name: '증감률',
                type: 'line',
                data: data?.growthRate || [-5, -1, 2, -2, 0, 1, 3],
                yAxis: 1,
                color: '#e74c3c',
                marker: {
                    symbol: 'circle',
                },
            },
        ],
        credits: {
            enabled: false,
        },
    };

    return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default PopulationGrowthChart;
